import deepEqual from 'deep-equal'
import numeral from 'numeral'
import { object, func, string, bool, number } from 'prop-types'
import { PureComponent } from 'react'
import { noop } from '@opallabs/kuiper'
import { getNestedProperty } from '@opallabs/lambda'
import BudgetInput from '../BudgetInput'

export const getTotalBudget = (parentBudget, context, budget) => {
  if (!parentBudget.id || !parentBudget.value) {
    return null
  }

  const budgetValue = budget.value || 0

  if (context === 'moment') {
    if (!budget.id) {
      return parseInt(parentBudget.value - parentBudget.moment_spend, 10)
    }

    return (
      parentBudget.value - parentBudget.moment_spend + parseInt(budgetValue, 10)
    )
  }

  return (
    parentBudget.value - parentBudget.post_spend + parseInt(budgetValue, 10)
  )
}

export default class BudgetInputManager extends PureComponent {
  static propTypes = {
    afterUpdate: func,
    budget: object,
    channel: string,
    checkGrandparentBudget: func,
    contentType: string,
    context: string,
    createBudget: func,
    dirtyValue: string,
    getBudget: func,
    getMomentId: func,
    getStoryId: func,
    modelId: number,
    name: string,
    onBudgetChange: func,
    parentBudget: object,
    parentContext: string,
    parentId: number,
    shouldUpdateBudget: bool,
    updateBudget: func,
  }

  static defaultProps = {
    budget: {},
    getMomentId: noop,
    getStoryId: noop,
  }

  constructor(props) {
    super(props)
    let budgetValue = null

    if (props.budget.id && props.budget.value !== null) {
      budgetValue = numeral(props.budget.value).format('0,0')
    }

    this.state = { value: budgetValue }
  }

  componentDidMount() {
    const { budget, context, dirtyValue, getBudget, modelId } = this.props
    if (modelId && !budget.id) {
      getBudget({ id: modelId, context })
    }
    if (dirtyValue) {
      this.setState({ value: numeral(dirtyValue).format('0,0') })
    }

    return this.updateParentBudget()
  }

  componentDidUpdate(prevProps) {
    const newValue = this.props.budget.value || null
    const prevValue = prevProps.budget.value || null
    this.updateParentBudget(prevProps)

    if (prevValue !== newValue && newValue !== null) {
      this.setState({ value: numeral(this.props.budget.value).format('0,0') })
    }

    if (this.props.shouldUpdateBudget && this.state.value !== prevValue) {
      this.createOrUpdateBudget()
    }

    return null
  }

  onChange = (value) => {
    this.setState({ value })
    this.props.onBudgetChange(value)
  }

  valueToString = () => {
    if (!this.state.value) {
      return null
    }

    return this.setState((prevState) => {
      const formattedValue = numeral(prevState.value).format('0,0')
      return { value: formattedValue }
    })
  }

  valueToInteger = () => {
    if (!this.state.value || this.state.value === '0') {
      return null
    }

    return this.setState((prevState) => {
      const formattedValue = numeral(prevState.value).value()
      return { value: formattedValue }
    })
  }

  createOrUpdateBudget() {
    const {
      afterUpdate,
      budget,
      context,
      createBudget,
      modelId,
      updateBudget,
    } = this.props

    let value = numeral(this.state.value).value()
    if (this.state.value === '') {
      value = null
    }
    const budgetValue = { budget: { value } }
    if (budget.id) {
      return updateBudget({
        id: budget.id,
        context,
        value: budgetValue,
        callback: afterUpdate,
      })
    }

    return createBudget({
      id: modelId,
      context,
      value: budgetValue,
      callback: afterUpdate,
    })
  }

  updateParentBudget(prevProps = {}) {
    const {
      budget,
      checkGrandparentBudget,
      context,
      parentBudget,
      parentContext,
      parentId,
    } = this.props

    if (!deepEqual(prevProps.parentBudget, parentBudget)) {
      this.setState({
        totalBudget: getTotalBudget(parentBudget, context, budget),
      })
    }

    if (parentId !== prevProps.parentId) {
      this.fetchParentBudget()
    }

    if (
      !getNestedProperty(parentBudget, 'value') &&
      parentContext === 'moment'
    ) {
      return checkGrandparentBudget()
    }

    return null
  }

  fetchParentBudget() {
    const { getBudget, parentContext, parentId } = this.props

    if (parentContext && parentId) {
      return getBudget({ id: parentId, context: parentContext })
    }

    return null
  }

  get value() {
    return this.state.value || ''
  }

  render() {
    return (
      <BudgetInput
        {...this.props}
        onBlur={this.valueToString}
        onFocus={this.valueToInteger}
        onChange={this.onChange}
        totalBudget={this.state.totalBudget}
        value={this.value}
      />
    )
  }
}
